// Library methods
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

import { getAllProgressionAnalysis } from "../../services/Exam";
import { getLocalDate, sortByOldestDate } from "../../utils/dateHelper";

export const useProgressionAnalysisList = ({
  clinicId,
  patientId,
  clinicTimezone,
}) => {
  const { getAccessTokenSilently } = useAuth0();

  const [isLoading, setIsLoading] = useState(true);
  const [progressionAnalysisList, setProgressionAnalysisList] = useState([]);

  // Fetching data
  useEffect(() => {
    const getExamDateRange = (examList) => {
      // get exams with a valid completion date
      const filteredExams = examList.filter((exam) => exam.completionDate);
      // sort by completion date
      const sortedArray = sortByOldestDate(filteredExams, "completionDate");

      // get earliest and latest completion dates
      const earliest =
        sortedArray.length > 0 ? sortedArray[0]?.completionDate : null;
      const latest =
        sortedArray.length > 0
          ? sortedArray[sortedArray.length - 1]?.completionDate
          : null;
      return { earliest, latest };
    };

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const token = await getAccessTokenSilently();
        const res = await getAllProgressionAnalysis(token, clinicId, patientId);
        const formattedList = res?.map((progressionAnalysis) => {
          // combine all exam types
          const allExams = [
            ...progressionAnalysis?.exams,
            ...progressionAnalysis?.externalExams,
          ];
          // get the earliest and latest exam dates
          const { earliest, latest } = getExamDateRange(allExams);

          // return the progression analysis object with earliest/latest dates
          return {
            ...progressionAnalysis,
            earliestCompletionLocalDate: earliest
              ? getLocalDate(earliest, clinicTimezone)
              : "N/A",
            latestCompletionLocalDate: latest
              ? getLocalDate(latest, clinicTimezone)
              : "N/A",
          };
        });
        setProgressionAnalysisList(formattedList);
      } catch (e) {
        console.error("Error fetching data:", e);
      } finally {
        setIsLoading(false);
      }
    };

    if (clinicId && patientId) {
      fetchData();
    }
  }, [clinicId, patientId, clinicTimezone, getAccessTokenSilently]);

  return { progressionAnalysisList, isLoading };
};
